import React, {Component} from 'react';

export default class AppSubMenu extends Component {
    constructor(props) {
        super(props);
        this.toggleRef = null;
        this.renderToggler = this.renderToggler.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', (e) => {
            if (!e.target || !this.props.toggle || !this.toggleRef) {
                return;
            }
            if (e.target === this.toggleRef || e.target.closest('.app-menu-toggle-button') === this.toggleRef) {
                return;
            }
            if (typeof this.props.toggle.props.onClick === 'function' && this.props.isOpen) {
                this.props.toggle.props.onClick();
            }

        });
    }

    renderToggler() {

        const {toggle} = this.props;
        const toggleProps = toggle ? toggle.props : {};
        const {children, onClick, className, ...restToggleProps} = toggleProps;
        return toggle ? <button
            ref={(r) => {
                this.toggleRef = r;
            }}
            {...restToggleProps}
            className={`app-menu-toggle-button ${className ? className : ''}`}
            onClick={(e) => {
                if (typeof onClick === 'function') {
                    onClick(e);
                }

            }}>{children}</button> : ''

    }

    render() {
        const {className, toggle, isOpen} = this.props;

        return <>
            {this.renderToggler()}

            <ul className={`main-menu__sub-menu ${isOpen ? 'is-active' : ''} ${className ? className : ''}`}>

                {this.props.children}
            </ul>
        </>;
    }

}
